import type { ImportOrderPhase13MatchedLineForm } from "./import-order-line-form";
import { importOrdersClient } from "../api/import-orders-client";

export async function enrichImportLinesWithLastPrices(
  lines: ImportOrderPhase13MatchedLineForm[],
): Promise<ImportOrderPhase13MatchedLineForm[]> {
  if (lines.length === 0) return lines;

  const { data } = await importOrdersClient.lastPrices(
    lines.map((line) => line.variantId),
  );
  const priceMap = new Map(data.map((row) => [row.variantId, row]));

  return lines.map((line) => {
    if (line.unitPriceForeign > 0) return line;

    const last = priceMap.get(line.variantId);
    const lastPrice =
      last?.unitPriceForeign != null ? Number(last.unitPriceForeign) : 0;

    if (lastPrice <= 0) return line;

    return {
      ...line,
      unitPriceForeign: lastPrice,
      priceFromHistory: true,
    };
  });
}
